export const INCOME_PERIOD_FORMAT = 'MMM YYYY';

export const CONTRACT_DATE_FORMAT = 'DD/MM/YYYY';

export const NEXT_STATEMENT_DATE_FORMAT = 'D MMM';

export const CALENDAR_EVENT_DATE_FORMAT = 'MM/DD';

export const CALENDAR_PAGE_TILE_FORMAT = 'D';

export const SONG_RELEASE_DATE_FORMAT = 'MM/DD/YYYY';

export const SONG_DETAILS_SHEETS_FORMAT = 'MM/DD/YYYY';

export const DEAL_DETAILS_SHEETS_FORMAT = 'DD/MM/YYYY';

export const DEAL_DETAILS_PAYMENT_FORMAT = 'Do MMM';

export const GLOBAL_DISPLAY_FORMAT = 'DD MMM YYYY';
